import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";
import { GET_TEMPLATE_SECTION_FIELD_LIST } from "../services/get-template-properties";
import {
  isMdaeWidgetOptionChangeEvent,
  updateStateAfterWidgetOptionChange,
} from "../../../../common_components/mdae-framework";
import { CaseSummaryPage } from "../constant";
export const SET_SELECTED_SECTION_VALUE = "SET_SELECTED_SECTION_VALUE";
export const TOGGLE_SECTION_FIELD_VALUE = "TOGGLE_SECTION_FIELD_VALUE";
export const TOGGLE_SECTION_VALUE = "TOGGLE_SECTION_VALUE";
export const REORDER_SECTION_LIST = "REORDER_SECTION_LIST";
export const SET_CLAIM_TYPE_VALUE = "SET_CLAIM_TYPE_VALUE";
export const SET_FILTERED_SECTION_FIELD_LIST =
  "SET_FILTERED_SECTION_FIELD_LIST";
export const SET_ENTITY_TYPE_VALUE = "SET_ENTITY_TYPE_VALUE";
export const TOGGLE_EDIT_TEMPLATE_POPUP = "TOGGLE_EDIT_TEMPLATE_POPUP";
export const SET_REPORT_BUILDER_TAB = "SET_REPORT_BUILDER_TAB";
export const SET_REPORT_TEMPLATE_ID = "SET_REPORT_TEMPLATE_ID";
export const SET_SETTINGS_FORM_DATA = "SET_SETTINGS_FORM_DATA";
export const SET_SETTINGS_FORM_DATA_AUDITGROUP =
  "SET_SETTINGS_FORM_DATA_AUDITGROUP";
export const SET_TEMPLATE_FORM_DATA = "SET_TEMPLATE_FORM_DATA";
export const TOGGLE_REPORT_TEMPLATE_WARNING_POPUP =
  "TOGGLE_REPORT_TEMPLATE_WARNING_POPUP";

const initialFormData = {
  settings: {},
  selectedAuditGroupIds: [],
  termDate: null,
  reportTemplateId: 0,
  replaceParentReport: false,
  reportTemplateName: "",
};

const initialState = {
  claimTypeValue: "P",
  orgSectionList: [],
  orgSectionFieldList: [],
  selectedSectionId: null,
  reportTemplateId: null,
  changedSectionList: [],
  changedSectionFieldList: [],
  filteredSectionList: [],
  filteredSectionFieldList: [],
  entityTypeValue: "PR",
  reportBuilderTabIndex: 0,
  isTemplatePopupVisible: false,
  templateFormData: initialFormData,
  isReportTemplateWarningPopupVisible: false,
  reportTemplateName:null
};

export default function(state = initialState, action) {
  let newState;
  switch (action.type) {
    case SET_SELECTED_SECTION_VALUE:
    case TOGGLE_EDIT_TEMPLATE_POPUP:
    case SET_CLAIM_TYPE_VALUE:
    case SET_FILTERED_SECTION_FIELD_LIST:
    case SET_REPORT_BUILDER_TAB:
    case REORDER_SECTION_LIST:
    case SET_ENTITY_TYPE_VALUE:
    case SET_REPORT_TEMPLATE_ID:
    case SET_TEMPLATE_FORM_DATA:
    case TOGGLE_REPORT_TEMPLATE_WARNING_POPUP:
      newState = { ...state };
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    case TOGGLE_SECTION_FIELD_VALUE:
      return {
        ...state,
        changedSectionFieldList: state.changedSectionFieldList.map((f) =>
          f.sectionId === action.data.sectionId &&
          f.fieldId === action.data.fieldId
            ? { ...f, fieldVisible: action.data.value }
            : f
        ),
        filteredSectionFieldList: state.filteredSectionFieldList.map((f) =>
          f.sectionId === action.data.sectionId &&
          f.fieldId === action.data.fieldId
            ? { ...f, fieldVisible: action.data.value }
            : f
        ),
      };
    case SET_SETTINGS_FORM_DATA: {
      return {
        ...state,
        templateFormData: {
          ...state.templateFormData,
          settings: {
            ...state.templateFormData.settings,
            ...action.data.templateFormData.settings,
          },
        },
      };
    }
    case TOGGLE_SECTION_VALUE:
      return {
        ...state,
        changedSectionList: state.changedSectionList.map((f) =>
          f.sectionId === action.data.sectionId
            ? { ...f, sectionVisible: action.data.value }
            : f
        ),
        filteredSectionList: state.filteredSectionList.map((f) =>
          f.sectionId === action.data.sectionId
            ? { ...f, sectionVisible: action.data.value }
            : f
        ),
      };
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_TEMPLATE_SECTION_FIELD_LIST)(action)) {
        return {
          ...state,
          orgSectionList: [],
          orgSectionFieldList: [],
          changedSectionList: [],
          changedSectionFieldList: [],
          filteredSectionList: [],
          filteredSectionFieldList: [],
        };
      }
      if (isAsyncComplete(GET_TEMPLATE_SECTION_FIELD_LIST)(action)) {
        const response = action.response;

        const orgSectionList = response.sectionList;
        const orgSectionFieldList = response.sectionFieldList;

        const changedSectionList = orgSectionList.map((s) => ({ ...s }));
        const changedSectionFieldList = orgSectionFieldList.map((f) => ({
          ...f,
        }));

        const filteredSectionList = changedSectionList.filter(
          (s) =>
            s.claimType ===
            (state.reportBuilderTabIndex == 0
              ? state.claimTypeValue
              : CaseSummaryPage)
        );
        const filteredSectionFieldList = changedSectionFieldList.filter(
          (f) =>
            f.claimType ===
              (state.reportBuilderTabIndex == 0
                ? state.claimTypeValue
                : CaseSummaryPage) &&
            (f.fieldType == state.entityTypeValue || f.fieldType == null)
        );

        return {
          ...state,
          orgSectionList: orgSectionList,
          orgSectionFieldList: orgSectionFieldList,
          changedSectionList: changedSectionList,
          changedSectionFieldList: changedSectionFieldList,
          filteredSectionList: filteredSectionList,
          filteredSectionFieldList: filteredSectionFieldList,
        };
      }
      return state;
    default:
      return state;
  }
}
